import { ReactElement } from "react";

import { useNavigate } from "../../../lib/navigate";
import { useSettings } from "../../../state/settings";
import { useKeyboardShortcuts } from "../../../lib/keyboard";
import { useDrawings } from "../../../state/drawings";
import { Drawing } from "../../../lib/drawing";
import { toPng } from "../../../lib/drawing/render";
import { download } from "../../../lib/data";
import Header from "../../shared/Header";
import IconButton from "../../shared/Icon/Button";

export default function EditHeader(props: { drawing: Drawing }): ReactElement {
  const navigate = useNavigate();
  const { settings } = useSettings();
  const { create, copy, remove } = useDrawings();

  function newDrawing(): void {
    requestAnimationFrame(() => {
      const id = create();
      navigate(`/edit/${id}`);
    });
  }

  function copyDrawing(): void {
    navigate("/");
    setTimeout(() => copy(props.drawing), 400);
  }

  function deleteDrawing(): void {
    if (window.confirm(`Delete this drawing forever?`)) {
      navigate("/");
      setTimeout(() => remove(props.drawing), 400);
    }
  }

  function downloadDrawing(): void {
    download({
      content: toPng(props.drawing, {
        transparentFill: settings.transparentFill,
        resolution: settings.resolution,
      }),
      name: "drawing",
      fileExtension: "png",
    });
  }

  useKeyboardShortcuts({
    close: () => navigate(-1),
    new: () => newDrawing(),
    copy: () => copyDrawing(),
    delete: () => deleteDrawing(),
    download: () => downloadDrawing(),
    shortcuts: () => navigate("/edit/shortcuts"),
    settings: () => navigate("/settings"),
  });

  return (
    <div>
      <Header
        menu={
          <>
            <IconButton name={"new"} tooltip="new" onClick={newDrawing} />

            <IconButton
              name={"copy"}
              tooltip="make copy"
              onClick={copyDrawing}
            />

            <IconButton
              name={"delete"}
              tooltip="delete"
              onClick={deleteDrawing}
            />

            <IconButton
              name={"download"}
              tooltip="download"
              onClick={downloadDrawing}
            />

            <IconButton
              name={"info"}
              onClick={() => navigate("/edit/shortcuts")}
              tooltip="shortcuts"
            />

            <IconButton
              name={"settings"}
              onClick={() => navigate("/settings")}
              tooltip="settings"
            />
          </>
        }
      />
    </div>
  );
}
